import { renderSocialIcons } from './SocialIcons.js';

/*
  About section - "The Monster Gets the Microphone". Third scroll-snap
  section. No cover image (director: "no need for any image, mock is
  sufficient as is"), no down-arrow (terminal section - nothing follows
  it). Closes with a small stitched-X signature mark instead of any
  navigational affordance, per director's steer away from icons that
  imply more scrolling.

  Structurally distinct from HeroSection.js (not a cover+CTA pattern) -
  this is a static text panel, so it gets its own component rather than
  being forced through HeroSection's config contract.
*/

export function renderAboutSection() {
  const section = document.createElement('section');
  section.className = 'relative w-full min-h-[100dvh] snap-start overflow-y-auto flex items-center justify-center bg-[#050507] px-6 py-10 landscape:py-8';

  section.innerHTML = `
    <div class="about-bg-glow" aria-hidden="true"></div>
    <div class="w-full max-w-[640px] mx-auto relative z-10">
      <div class="w-14 h-px mb-8 mx-auto about-divider"></div>

      <h1 class="text-center about-title">STYGIAN MYTH</h1>
      <p class="text-center about-tagline">The Monster Gets the Microphone</p>

      <div class="about-panel">
        <p>If you found me before reading the stories, fortune smiled on you.</p>
        <p>Here's a piece of advice: <em>if a voice is gentle, watch your pocket.</em></p>
        <p>For those who found me after&hellip; well, you've already been introduced.</p>
        <p>Everything on this site is a scrap from the kitchen. <span class="about-emphasis">NINE DEATHS</span> is what's still on the stove.</p>
        <p>If you survived the experience, you can track me down on the other side.</p>

        <div class="about-signoff">
          <span>&mdash; S.</span>
        </div>
      </div>

      <div class="about-socials" data-role="about-socials"></div>
    </div>
  `;

  const socialsWrap = section.querySelector('[data-role="about-socials"]');
  socialsWrap.appendChild(renderSocialIcons({ variant: 'about' }));

  return section;
}
